import {
    Box,
    Text,
    Avatar,
    Flex,
    useRadio,
    UseRadioProps,
    chakra
} from '@chakra-ui/react'

function UserSelectRadioCard(props: UseRadioProps & { parent: Record<string, any> }) {
    const { parent, ...radioProps } = props
    const { state, getInputProps, getRadioProps, htmlProps, getLabelProps } =
        useRadio(radioProps)

    return (
        <chakra.label {...htmlProps} cursor="pointer">
            <input {...getInputProps({})} hidden />
            <Box
                {...getRadioProps()}
                bg={state.isChecked ? 'brand.50' : 'transparent'}
                cursor="pointer"
                borderWidth="1px"
                borderRadius="md"
                boxShadow="md"
                borderColor="brand.50"
                px={5}
                py={3}
            >
                <Flex {...getLabelProps()}>
                    <Avatar
                        name={`${parent.firstName} ${parent.lastName}`}
                        src={parent.picture}
                    />
                    <Box ml="3" textAlign={'left'}>
                        <Text fontWeight="bold">
                            {`${parent.firstName} ${parent.lastName}`}
                        </Text>
                        <Text fontSize="sm">
                            {(parent?.relationship && 'Parent') || 'Guardian'}
                        </Text>
                    </Box>
                </Flex>
            </Box>
        </chakra.label>
    )
}

export default UserSelectRadioCard
